import React, { useEffect } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { useNavigate } from '../../../hooks/useNavigate';

export function Onboarding() {
  const navigate = useNavigate();
  const { billingStatus } = useAuth();

  useEffect(() => {
    if (billingStatus.isActive) {
      navigate('/onboarding/pro');
    } else {
      navigate('/onboarding/free');
    }
  }, []);

  return <>Loading</>;
}
